import React from 'react'
import styled, { css } from 'styled-components'
import { breakpoint } from '../layout/styles'

const VideoBanner = ({ data }: any) => {
  const [playing, setPlaying] = React.useState<boolean>(false)
  const ref = React.useRef<any>(null)
  const handlePlay = () => {
    if (!data.mp4_video) {
      // YouTube path — no <video> element; just flip the state so the iframe renders
      setPlaying(true)
      return
    }
    const video = ref.current
    // Guard against clicks that fire before the <video> element has mounted
    if (!video) return
    setPlaying(video.paused)
    if (video.paused) {
      video.play()
    } else {
      video.pause()
    }
  }
  return (
    <VideoContainer>
      {!playing && (
        <PlayContainer hosted={!data.youtube_id}>
          <Content onClick={handlePlay}>
            <h3>{data.title}</h3>
            <PlayButton />
          </Content>
        </PlayContainer>
      )}
      {data.mp4_video && (
        <video style={{ width: '100%' }} muted loop playsInline ref={ref} onClick={handlePlay}>
          <source src={data.mp4_video.url} type="video/mp4" />
        </video>)}
      {data.youtube_cover?.url && data.youtube_id && !playing &&  
        <img src={`${data.youtube_cover.url}?width=2000&auto=webp&format=pjpg&quality=75`} alt="cover" aria-hidden />}
      {data.youtube_id && playing &&
        <iframe width="100%" height="692px" src={`https://www.youtube-nocookie.com/embed/${data.youtube_id}?rel=0&autoplay=1`} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>}
    </VideoContainer>
  )
}

export default VideoBanner

export const VideoContainer = styled.div`
  position: relative;
  overflow: hidden;
  video, img {
    cursor: pointer;
    object-fit: cover;
    object-position: center center;
    min-height: 695px;
    display: block;
    width: 100%;
  }
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const PlayContainer = styled.div<any>`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  ${props => props.hosted && css`pointer-events: none`};
  display: flex;
  align-items: center;
  justify-content: center;
  &:before {
    content: '';
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1;
    position: absolute;
    background: rgb(0, 0, 0);
    background: linear-gradient(to top, rgba(0, 0, 0, 0.5) 25%, rgba(0, 0, 0, 0) 100%);
    @media ${breakpoint.desktop} {
      background: linear-gradient(to right, rgba(0, 0, 0, 0.5) 25%, rgba(0, 0, 0, 0) 100%);
    }
  }
  h3 {
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    text-align: center;
    color: white;
    position: relative;
    z-index: 2;
    margin: 20px 60px;
    @media ${breakpoint.desktop} {
      font-size: 36px;
    }
  }
`

const PlayButton = styled.div`
  width: 82px;
  height: 82px;
  border-radius: 100%;
  cursor: pointer;
  z-index: 1;
  background: white url(/images/play.svg) no-repeat scroll 30px center;
`
